import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoint, colors, typography } from '../../../themes/stena-recycling';

export const SegmentWrapper = styled.div`
  display: inline-flex;
  padding: 4px;
  align-items: flex-start;
  gap: 4px;
  border-radius: 8px;
  background: ${colors.monochrome.grey10};

  @media (max-width: ${breakpoint.medium}px) {
    display: none;
  }
`;

export const SegmentButton = styled.button<{ isSelected: boolean }>`
  all: unset;
  ${typography.body.large};
  cursor: pointer;
  padding: 4px 12px;
  gap: 4px;
  border-radius: 4px;
  background: ${({ isSelected }) => (isSelected ? '#fff' : colors.monochrome.grey10)};
  color: ${({ isSelected }) => (isSelected ? colors.base.black : colors.primary.grey)};

  ${({ isSelected }) => {
    if (!isSelected) {
      return css`
        &:hover {
          background: rgba(255, 255, 255, 0.5);
        }
      `;
    }
  }}
`;

export const MobileStyle = styled.div`
  @media (min-width: ${breakpoint.medium + 1}px) {
    display: none;
  }

  width: 100%;
`;
